import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-12 grid-nogutter"
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "flex mt-4 info-connect" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "flex mt-4 app-label-small text-gray-l1 font-bold" }
const _hoisted_7 = {
  key: 1,
  class: "col-12 grid-nogutter"
}
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "flex mt-4 info-connect" }
const _hoisted_10 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (!_ctx.loggedIn)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('login-page.login-title')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_app_button, {
            class: "mt-4 w-full",
            buttonType: "main",
            buttonSize: "m",
            buttonText: _ctx.$t('login-page.login'),
            onClick: _ctx.ssoLogin
          }, null, 8, ["buttonText", "onClick"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: "/password/reset" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('login-page.forgotten-password')) + " ?", 1)
            ]),
            _: 1
          })
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('login-page.already-logged')), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, { to: "/home" }, {
            default: _withCtx(() => [
              _createVNode(_component_app_button, {
                class: "flex main mt-4",
                buttonType: "main",
                buttonSize: "m",
                buttonText: _ctx.$t('button-label.back-home')
              }, null, 8, ["buttonText"])
            ]),
            _: 1
          })
        ])
      ]))
}